import { render, staticRenderFns } from "./modalConfirmarResgate.vue?vue&type=template&id=6ec5c380&scoped=true"
import script from "./modalConfirmarResgate.vue?vue&type=script&lang=js"
export * from "./modalConfirmarResgate.vue?vue&type=script&lang=js"
import style0 from "./modalConfirmarResgate.vue?vue&type=style&index=0&id=6ec5c380&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec5c380",
  null
  
)

export default component.exports